import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6477adff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BoxList" }
const _hoisted_2 = { class: "BoxImage" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BoxGap" }, null, -1))
const _hoisted_4 = { class: "Text" }
const _hoisted_5 = { class: "Title" }
const _hoisted_6 = { class: "Caption" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BoxGap" }, null, -1))
const _hoisted_8 = { class: "Text" }
const _hoisted_9 = { class: "Caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSVG = _resolveComponent("InlineSVG")!
  const _component_OverviewBox = _resolveComponent("OverviewBox")!

  return (_openBlock(), _createBlock(_component_OverviewBox, {
    class: "CategoriesBox",
    link: {
      icon: 'types',
      to: 'RegistredMaterials',
      title: _ctx.mixWB('VIEW_ALL_BUILDING_PARTS'),
    }
  }, _createSlots({
    meta: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.data.metaText), 1)
    ]),
    list: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.list, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.hashID
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_InlineSVG, {
                class: "LargeIcon",
                src: require(`@/assets/svg/categories/${item.icon}.svg`)
              }, null, 8, ["src"])
            ]),
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.mixWB(item.translation)), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.onlineTypes.allRelated.length === 1
                ? _ctx.mixWB('1_TYPE')
                : _ctx.mixWB('X_TYPES', [item.onlineTypes.allRelated.length.toString()])), 1)
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.mixWB('TONNES_2')), 1),
              _createElementVNode("span", null, _toDisplayString(item.texts.tons.allRelated), 1)
            ])
          ], 64))
        }), 128))
      ])
    ]),
    _: 2
  }, [
    (_ctx.data.all.length >= 3)
      ? {
          name: "subHeader",
          fn: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.mixWB('THE_X_BUILDING_PARTS_WITH_THE_MOST_MATERIALS', ['3'])), 1)
          ])
        }
      : undefined,
    (!_ctx.data.all.length)
      ? {
          name: "noData",
          fn: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('NO_TYPES_REGISTERED_YET')), 1)
          ])
        }
      : undefined
  ]), 1032, ["link"]))
}